// extracted by mini-css-extract-plugin
module.exports = {"msgInput":"contributionForm_msgInput__Hr_Xn","summerGameMessage":"contributionForm_summerGameMessage__DUyvx"};